var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightbulb2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lightbulb_FILL0_wght400_GRAD0_opsz24 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 21.9999C11.45 21.9999 10.9792 21.804 10.5875 21.4124C10.1958 21.0207 10 20.5499 10 19.9999H14C14 20.5499 13.8042 21.0207 13.4125 21.4124C13.0208 21.804 12.55 21.9999 12 21.9999ZM9 18.9999C8.71667 18.9999 8.47917 18.904 8.2875 18.7124C8.09583 18.5207 8 18.2832 8 17.9999C8 17.7165 8.09583 17.479 8.2875 17.2874C8.47917 17.0957 8.71667 16.9999 9 16.9999H15C15.2833 16.9999 15.5208 17.0957 15.7125 17.2874C15.9042 17.479 16 17.7165 16 17.9999C16 18.2832 15.9042 18.5207 15.7125 18.7124C15.5208 18.904 15.2833 18.9999 15 18.9999H9ZM8.25 15.9999C7.1 15.3165 6.1875 14.3999 5.5125 13.2499C4.8375 12.0999 4.5 10.8499 4.5 9.49988C4.5 7.41654 5.22917 5.64571 6.6875 4.18738C8.14583 2.72904 9.91667 1.99988 12 1.99988C14.0833 1.99988 15.8542 2.72904 17.3125 4.18738C18.7708 5.64571 19.5 7.41654 19.5 9.49988C19.5 10.8499 19.1625 12.0999 18.4875 13.2499C17.8125 14.3999 16.9 15.3165 15.75 15.9999H8.25ZM8.85 13.9999H15.15C15.9 13.4665 16.4792 12.8082 16.8875 12.0249C17.2958 11.2415 17.5 10.3999 17.5 9.49988C17.5 7.96654 16.9667 6.66654 15.9 5.59988C14.8333 4.53321 13.5333 3.99988 12 3.99988C10.4667 3.99988 9.16667 4.53321 8.1 5.59988C7.03333 6.66654 6.5 7.96654 6.5 9.49988C6.5 10.3999 6.70417 11.2415 7.1125 12.0249C7.52083 12.8082 8.1 13.4665 8.85 13.9999Z",
    fill: "#104239"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulb2);
export default __webpack_public_path__ + "static/media/lightbulb-2.b7d1d1c9808478a03dd3ea9ed98d7fff.svg";
export { ForwardRef as ReactComponent };